<ng-template let-item #menuItem>
  <ng-container *ngIf="item.menuItem.children?.length; else simpleMenuItem">
    <ng-container
      *ngTemplateOutlet="
        expandableMenuItem;
        context: {
          $implicit: { menuItem: item.menuItem, level: item.level }
        }
      "
    ></ng-container
  ></ng-container>
  <ng-template #simpleMenuItem>
    <a
      mat-list-item
      [routerLink]="item.menuItem.routerLink"
      [appIfHasRoles]="item.menuItem.userRole"
      [routerLinkActive]="'active'"
      [class.active]="activeMenuUrl === item.menuItem.routerLink"
      class="sidenav-list-item menu-level-{{ item.level }}"
      [disabled]="item.menuItem.isDisabled ? true : null"
    >
      {{ item.menuItem.title | translate }}
    </a>
  </ng-template>
</ng-template>

<ng-template #expandableMenuItem let-item>
  <mat-expansion-panel
    [appIfHasRoles]="item.menuItem.userRole"
    [routerLinkActive]="'active'"
    [id]="item.menuItem.rootUrl"
    #expPanels
  >
    <mat-expansion-panel-header class="menu-level-{{ item.level }}">
      <mat-panel-title class="sidenav-list-item">
        {{ item.menuItem.title | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ul>
      <li
        *ngFor="let childItem of item.menuItem.children"
        [appIfHasRoles]="childItem.userRole"
      >
        <ng-container
          *ngTemplateOutlet="
            menuItem;
            context: {
              $implicit: { menuItem: childItem, level: item.level + 1 }
            }
          "
        ></ng-container>
      </li>
    </ul>
  </mat-expansion-panel>
</ng-template>

<mat-nav-list>
  <div *ngFor="let item of menuItems" class="root-menu">
    <ng-container
      *ngTemplateOutlet="
        menuItem;
        context: { $implicit: { menuItem: item, level: 1 } }
      "
    ></ng-container>
  </div>
</mat-nav-list>
